import React from 'react';
import './Hero.css';

const Hero = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToProjects = () => {
    const element = document.getElementById('projects');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="hero">
      <div className="hero-overlay"></div>
      <div className="hero-content">
        <h1 className="hero-title">
          Building Your <span className="highlight">Dreams</span> Into Reality
        </h1>
        <p className="hero-subtitle">
          Professional construction services with over 20 years of excellence. 
          From residential to commercial projects, we deliver quality craftsmanship.
        </p>
        <div className="hero-buttons">
          <button className="btn btn-primary" onClick={scrollToContact}>
            Get A Quote
          </button>
          <button className="btn btn-secondary" onClick={scrollToProjects}>
            View Projects
          </button>
        </div>
      </div>
      <div className="hero-stats">
        <div className="stat">
          <h3>500+</h3>
          <p>Projects Completed</p>
        </div>
        <div className="stat">
          <h3>20+</h3>
          <p>Years Experience</p>
        </div>
        <div className="stat">
          <h3>100%</h3>
          <p>Client Satisfaction</p>
        </div>
      </div>
    </section>
  );
};

export default Hero;
